import { render, staticRenderFns } from "./NotificationData.vue?vue&type=template&id=124200de&scoped=true"
import script from "./NotificationData.vue?vue&type=script&lang=ts"
export * from "./NotificationData.vue?vue&type=script&lang=ts"
import style0 from "./NotificationData.vue?vue&type=style&index=0&id=124200de&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124200de",
  null
  
)

export default component.exports